import { ErrorBanner, SkeletonRows } from '@patchbay/ui'
import type { UseQueryResult } from '@tanstack/react-query'
import type * as React from 'react'
import { describeError } from '../../lib/api/client'

/**
 * Loading / failed / ready for one tab's query. A failed read is an error banner with Retry, never an empty table or a
 * row of zeros (P11).
 */
export function QueryView<T>({
  query,
  what,
  children,
}: {
  query: UseQueryResult<T>
  what: string
  children: (data: T) => React.ReactNode
}) {
  if (query.isPending) return <SkeletonRows count={6} />
  if (query.isError || query.data === undefined) {
    return (
      <ErrorBanner
        title={`${what} could not load`}
        detail={`${describeError(query.error)}. Nothing is shown rather than a figure we cannot stand behind.`}
        onRetry={() => void query.refetch()}
      />
    )
  }
  return <>{children(query.data)}</>
}
